export const INITIATIVES_API_PATHS = {
    INITIATIVES: '/initiatives',
    INITIATIVE_TYPES: '/initiatives/types',
    INITIATIVE_CATEGORIES: '/initiatives/categories',
    INITIATIVE_KPIS: '/initiatives/kpis',
    INITIATIVE_KPI_UNITS: '/initiatives/kpi-units',
    INITIATIVE_OVERVIEW: '/initiatives/overview',
    INITIATIVE_EXPORT: '/initiatives/export',
};
